import {GetProductBulkResponse} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/article_detail_page/v1/service.types';
import {BackButton, Z_INDEXES} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React from 'react';
import {useAppendFirstProductIdCallback} from '../../../features/firstProductId/useFirstProductIds';

export type GoBackWithCategoryLabelQuickViewProps = {
  className?: string;
};

export const GoBackWithCategoryLabelQuickViewView: React.FC<
  GetProductBulkResponse['linksSection'] & GoBackWithCategoryLabelQuickViewProps
> = ({backLinkTarget, className}) => {
  const appendFirstProductIdCallback = useAppendFirstProductIdCallback();
  const backLink = backLinkTarget?.url;

  if (!backLink) {
    return null;
  }

  const [pathname, search] = backLink.split('?');
  const searchWithFirstProductId = appendFirstProductIdCallback(
    new URLSearchParams(search),
  );

  const backLinkWithQueryParams = `${pathname}${searchWithFirstProductId}`;

  return (
    <GoBackButton
      className={className}
      testId="backButton_directEntry"
      href={backLinkWithQueryParams}
      iconType="cross"
      iconSize="SS"
      showAsButton={true}
    />
  );
};

const GoBackButton = styled(BackButton)`
  &&& {
    position: absolute;
    top: 5px;
    left: -2px;
    z-index: ${Z_INDEXES.ADP_BACK_BUTTON};
  }
`;
